import React from 'react';
import PropTypes from 'prop-types';
import EventDetailsSideBar from '../RepVisitsCalendarEventDetailsSideBar';
import OverviewNoResults from './overview-no-results';
import OverviewResults from './overview-results';
import SidebarWrapper from '../../components/SidebarWrapper';
import PageTitle from '../../components/PageTitle';
import './styles.css';
import Loader from '../../components/Loader';

class RepVisitsOverview extends React.PureComponent {
  static propTypes = {
    displaySidebarComponent: PropTypes.func,
    closeSidebar: PropTypes.func,
    visible: PropTypes.bool,
    showSideBar: PropTypes.func,
    viewer: PropTypes.shape({
      repVisitsEvents: PropTypes.array,
      enabledFeatures: PropTypes.array,
      uuid: PropTypes.string,
    }),
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
    }),
  };

  static defaultProps = {
    viewer: {
      repVisitsEvents: [],
    },
    data: {
      loading: true,
    },
  };

  state = {
    notification: null,
  };

  removeNotification = () => {
    this.setState({ notification: null });
  };

  onSave = (notification) => {
    this.setState({ notification: React.cloneElement(notification, { onDeactivate: this.removeNotification }) });
    this.props.closeSidebar();
  };

  showSideBar = (event) => {
    const schoolIdParam = { id: event.highSchoolId };
    this.props.displaySidebarComponent(
      <SidebarWrapper.Bar>
        <EventDetailsSideBar
          visible
          onSave={this.onSave}
          event={event}
          params={schoolIdParam}
        />
      </SidebarWrapper.Bar>,
    );
  };

  render() {
    const { data, viewer, viewer: { enabledFeatures, uuid } } = this.props;
    const { repVisitsEvents } = viewer;
    const { loading } = data;
    const isCommunityServerlessOn = enabledFeatures?.includes('COMMUNITYSERVERLESS');

    return (
      <div styleName="overview-results">
        <PageTitle subTitle="Overview" title="RepVisits" category="Intersect" />

        {this.state.notification}
        {loading && <Loader active />}
        {!loading && repVisitsEvents.length > 0 && (
          <OverviewResults
            showSideBar={this.showSideBar}
            repVisitsEvents={repVisitsEvents}
            isCommunityServerlessOn={isCommunityServerlessOn}
            uuid={uuid}
          />
        )}
        {!loading && !repVisitsEvents.length && <OverviewNoResults />}
      </div>
    );
  }
}

export default RepVisitsOverview;
